/**
 * Global UI class
 */
import addressCompletion from './components/address_completion';
import registrantInput from './components/registrant_input';
import campaignFields from './components/campaign_fields';

window.$      = window.jQuery = require('jquery/dist/jquery.min');
window.Popper = require('popper.js/dist/umd/popper.min');
require('bootstrap/dist/js/bootstrap.bundle');
require('select2/dist/js/select2.full.min');
$.fn.select2.defaults.set('theme', 'bootstrap4');

let resizeDebouncer = null;

/**
 * Initialize a container of HTML
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    // Initialize tooltips
    $container.find('[data-toggle="tooltip"]').each(function() {
        let settings = $(this).data('plugin-options') || {};
        $(this).tooltip($.extend(settings, {html: true}));
    });

    // Initialize select boxes
    $container.find('select').each(function() {
        let options = {width: '100%', minimumResultsForSearch: 5};
        if ($(this).attr('placeholder') !== undefined) {
            options.placeholder = $(this).attr('placeholder');
        }
        if ($(this).attr('data-registrant-input') !== undefined) {
            options.tags = $(this).attr('data-registrant-input');
        }
        $(this).select2(options);
    });

    registrantInput.initializeContainer($container);
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
    initialize:          function() {
        // Initialize the body as a container
        let $body = $('body');

        $(document).ready(function() {
            initializeContainer($body);
        });

        // Initialize file upload styling
        $(document).on('change', '.form-group.file input[type="file"]', function(event) {
            let files = $(this).prop('files');
            if (files.length === 1) {
                let $fileNameContainer = $(this).closest('.form-group').find('.file-name');
                $fileNameContainer.removeClass('text-muted');
                if (files[0].name) {
                    $fileNameContainer.html(files[0].name);
                } else {
                    $fileNameContainer.html(event.target.value.split('\\').pop());
                }
            }
        });

        registrantInput.initialize();
        campaignFields.initialize();

        // Initialize form submission flag for onbeforeunload
        window._showUnloadMessage = window._showUnloadMessage || false;

        // Ensure that on any change of the form inputs the unload message is shown
        $(document).on('change', 'form input, form select', function() {
            window._showUnloadMessage = true;
        });

        // Ensure all forms have a loader on submission
        $(document).on('submit', 'form', function() {
            // Ensure form submission does not trigger unload message
            window._showUnloadMessage = false;

            let $form = $(this);
            $form.find('[name]').blur();

            let formId       = $form.attr('id');
            let $loadElement = $form;
            if (formId !== undefined && $form.closest(`[data-load-for="${formId}"]`).length > 0) {
                $loadElement = $form.closest(`[data-load-for="${formId}"]`);
            }
            if ($loadElement.hasClass('loading')) {
                return false;
            }
            $loadElement.addClass('loading');
        });

        // Ensure links do not trigger unload message
        $(document).on('click', 'a:not([href^="#"])', function() {
            window._showUnloadMessage = false;
            return true;
        });

        // Ensure the possibly present footer has enough space
        $(document).ready(function() {
            let $footer = $('footer');
            if ($footer.length === 1) {
                $(window).resize(function() {
                    if (resizeDebouncer) {
                        clearTimeout(resizeDebouncer);
                    }
                    resizeDebouncer = setTimeout(function() {
                        $body.css('padding-bottom', $('footer').outerHeight());
                    }, 100);
                }).trigger('resize');
            }
        });

        addressCompletion.initialize();
    },
};



// WEBPACK FOOTER //
// ./build/script/src/ui.js